import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { initMap } from 'reducers/mapview/actions';
import { initializeMap } from '../../controllers/esriMapController';
import { Loader } from './Loader';
import './mapview.scss';

import { BasemapSelector } from './BasemapSelector';
import DrawShape from '../DrawShape/DrawShape';
import DrawShapeButton from '../DrawShapeButton/DrawShapeButton';
import LeftPanel from '../LeftPanel/LeftPanel';
//import WelcomeModal from './WelcomeModal';

export class MapView extends Component {
  componentDidMount() {
    initializeMap(this.mapview);
  }

  render() {
    const { error, expandDrawPanel, loaderActive } = this.props;

    return (
      <div className="mapview-container">
        {loaderActive.active && (
          <Loader loadingText={loaderActive.loadingText} />
        )}
        {error && <div>There was an error loading the MapView</div>}
        {!error && (
          <div
            className="mapview"
            ref={ref => {
              this.mapview = ref;
            }}
          />
        )}

        {/* <WelcomeModal /> */}
        <DrawShapeButton />
        {expandDrawPanel && <DrawShape />}
        <LeftPanel />

        <BasemapSelector />
      </div>
    );
  }
}

// export default MapView;
MapView.propTypes = {
  // dispatch: PropTypes.func.isRequired,
  initMap: PropTypes.func.isRequired,
  error: PropTypes.bool
};

MapView.defaultProps = {
  error: false
};

const mapStateToProps = ({
  mapview: { layers, error, expandDrawPanel, loaderActive }
}) => ({
  mapLayers: layers,
  error,
  expandDrawPanel,
  loaderActive
});

const mapDispatchToProps = dispatch => ({
  initMap: container => {
    dispatch(initMap(container));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(MapView);
